import React, { useState } from 'react';
import {
  Button,
  Radio,
  RadioGroup,
  Dropdown,
  Option,
  makeStyles,
} from '@fluentui/react-components';
import { BaseDialog } from './BaseDialog';

const useStyles = makeStyles({
  radioGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    marginBottom: '24px',
  },
  typeSection: {
    marginTop: '16px',
  },
  typeLabel: {
    fontWeight: '600',
    fontSize: '14px',
    marginBottom: '8px',
  },
});

interface GenerateBarcodesModalProps {
  isOpen: boolean;
  onClose: () => void;
  customerCount: number;
  onGenerate: (data: GenerateBarcodesData) => void;
}

export interface GenerateBarcodesData {
  action: 'createNew' | 'replace';
  barcodeType: string;
}

export default function GenerateBarcodesModal({
  isOpen,
  onClose,
  customerCount,
  onGenerate,
}: GenerateBarcodesModalProps) {
  const styles = useStyles();
  const [selectedAction, setSelectedAction] = useState<'createNew' | 'replace'>('createNew');
  const [barcodeType, setBarcodeType] = useState('Code 128');

  const handleGenerate = () => {
    const data: GenerateBarcodesData = {
      action: selectedAction,
      barcodeType,
    };
    onGenerate(data);
    handleCancel();
  };

  const handleCancel = () => {
    setSelectedAction('createNew');
    setBarcodeType('Code 128');
    onClose();
  };

  return (
    <BaseDialog
      isOpen={isOpen}
      onClose={handleCancel}
      title={`Generate barcodes for ${customerCount} customers`}
      maxWidth="560px"
      showCloseButton={true}
      contentPadding="24px"
      actions={
        <>
          <Button appearance="secondary" onClick={handleCancel}>
            Cancel
          </Button>
          <Button appearance="primary" onClick={handleGenerate}>
            Generate barcodes
          </Button>
        </>
      }
    >
      <div>
            <RadioGroup
              value={selectedAction}
              onChange={(e, data) => setSelectedAction(data.value as any)}
              className={styles.radioGroup}
            >
              <Radio value="createNew" label="Create barcodes for items that don't have barcodes yet" />
              <Radio value="replace" label="Replace existing barcodes with new ones" />
            </RadioGroup>

            <div className={styles.typeSection}>
              <div className={styles.typeLabel}>Type</div>
              <Dropdown
                value={barcodeType}
                selectedOptions={[barcodeType]}
                onOptionSelect={(e, data) => setBarcodeType(data.optionValue || 'Code 128')}
              >
                <Option value="Code 128">Code 128</Option>
                <Option value="Code 39">Code 39</Option>
                <Option value="EAN-13">EAN-13</Option>
                <Option value="EAN-8">EAN-8</Option>
                <Option value="UPC-A">UPC-A</Option>
                <Option value="QR Code">QR Code</Option>
              </Dropdown>
            </div>
      </div>
    </BaseDialog>
  );
}
